import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle } from "@angular/router";

import { RouteCachingService } from "src/app/@theme/shared/services/route-caching.service";

export class CareersRouteReuseStrategy implements BaseRouteReuseStrategy {
  // route data property name used to set a component as reusable from withing the routing configuration
  private reusePropertyName: string = 'reuse';

  constructor(private _routeCachingService: RouteCachingService) {}

  /**
   * 1. Checks if the route configuration for the target route (future) matches the route configuration for the current route (curr).
   * @param future navigation target route
   * @param curr current route
   * @returns
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  /**
   * 2. Determines if a cached instance of the component for the target route exists.
   * If it returns true, Angular calls the `retrieve` method to restore the cached component.
   * If it returns false, Angular will create and initialize a new component instance.
   * @param route
   * @returns
   */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const isComponentCached: boolean = !!route.routeConfig && !!this._routeCachingService.retrieve(route);
    return isComponentCached;
  }

  /**
   * 3. Retrieves the cached component for the given route.
   * @param route
   */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const storedRoute = this._routeCachingService.retrieve(route);
    return storedRoute;
  }

  /**
   * 4. Determines if the component we are navigating away from should be cached.
   * If it returns true, Angular calls the `store` method to save the component for future use.
   * If it returns false, Angular destroys the component.
   * @param route
   * @returns
   */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const shouldDetachRoute: boolean = !!route.routeConfig && !!route.data[this.reusePropertyName];
    return shouldDetachRoute;
  }

   /**
   * 5. Stores the component for the given route in the cache
   * @param route
   * @param detachedTree
   */
  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    if (!!route.routeConfig && !!route.data[this.reusePropertyName] && detachedTree) {
      this._routeCachingService.store(route, detachedTree);
    }
  }
}
